import React from 'react';
import {Redirect, Route, useLocation} from 'react-router-dom';
import {connect} from 'react-redux';

import {isLoggedIn, isLoggedInCustomer} from '../utils/auth';

function ProtectedRoute({component: Component, ...rest}) {
    const {auth} = rest;
    const location = useLocation();

    const isAuthorized = isLoggedInCustomer(auth);
    const pathname = location.pathname;

    return (
        <Route {...rest} render={
            props => {
                if (pathname === '/login' || pathname === '/forgot-password') {
                    if (isAuthorized) {
                        return <Redirect to={
                            {
                                pathname: '/profile',
                                state: {
                                    from: props.location
                                }
                            }
                        }/>;
                    } else return <Component {...rest} {...props} />;
                } else if (isAuthorized) {
                    return <Component {...rest} {...props} />;
                } else {
                    return <Redirect to={
                        {
                            pathname: '/',
                            state: {
                                from: props.location
                            }
                        }
                    }/>;
                }
            }
        }/>
    );
}

const mapStateToProps = state => ({auth: state.auth});

export default connect(mapStateToProps, null)(ProtectedRoute);
